import steps from './steps';
import getCurrentStep from './accessibleSteps/getCurrentStep';
import getAccessibleSteps from './accessibleSteps/getAccessibleSteps';
import getNextAccessibleStep from './accessibleSteps/getNextAccessibleStep';
import readFromCache from '~/util/apollo/readFromCache';
import formatStoreToProps from '~/graphql/queries/Application/util/formatStoreToProps';
import { GoToNextNavigatorStep } from './types';
import formatSearchParams from '~/util/formatSearchParams';

const applicationQuery = require('~/graphql/queries/Application/applicationQuery.graphql');

const formatOverride = (override: GoToNextNavigatorStep['override']) => {
  const { url, params } = override;

  return `${url}${formatSearchParams(params)}`;
};

const goToNextNavigatorStep = ({ push, props, override = null }: GoToNextNavigatorStep) => {
  if (override) {
    return push(formatOverride(override));
  }

  const { client, application, flow } = props;

  const variables = {
    application_id: application.id,
  };

  const dataInStore = readFromCache(client, applicationQuery, variables);
  const formattedData = formatStoreToProps(dataInStore, props);
  const flowSteps = steps[flow];
  const currentStep = getCurrentStep(flowSteps);
  const accessibleSteps = getAccessibleSteps(flowSteps, formattedData);
  const nextAccessibleStep = getNextAccessibleStep({
    steps: flowSteps,
    accessibleSteps,
    currentStep,
  });

  push(`${nextAccessibleStep.route}${formatSearchParams()}`);
};

export default goToNextNavigatorStep;
